import { render, staticRenderFns } from "./DsalesCreate.vue?vue&type=template&id=4b267a62&scoped=true"
import script from "./DsalesCreate.vue?vue&type=script&lang=js"
export * from "./DsalesCreate.vue?vue&type=script&lang=js"
import style0 from "./DsalesCreate.vue?vue&type=style&index=0&id=4b267a62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b267a62",
  null
  
)

export default component.exports